import axios from "axios";
export const baseURL = "https://back-ekselapp.appssquare.com/api";
const instance = axios.create({
  baseURL,
  headers: {
    Authorization: `Bearer ${
      localStorage.getItem("id_token") && localStorage.getItem("id_token")
    }`,
  },
});

export default instance;
